import React, {useEffect, useState, useMemo, useRef} from 'react';
import {connect} from 'react-redux';
import Config from '../../../Config';
import {Container, Row, Col} from 'reactstrap';
import {isMobileOnly as isMobile, isTablet, withOrientationChange} from 'react-device-detect';
import {
  popupReasonEnum,
  searchParametersEnum,
  pages,
  lobbyTabsEnum,
  customerTypeEnum,
  lobbyTabsButtons,
  lobbyTabsButtonsToSelfCare,
  lobbyTabsButtonsBusinessIndividualWithoutPackagesButtons,
  otpValidationPopupContent,
  lobbyTabsButtonsBusinessIndividual,
  saleActiveStep,
  saleOTPSteps,
} from './cellcomAbroadVariables';
import loginSubTypes from '../../../constans/loginSubTypes';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
//store functions
import {
  getEpiGeneralData,
  setLoading,
  epiStyleInitialization,
  resetState,
  setActiveLobbyTab,
  goToPage,
  openModal,
  closeModal,
  validateCustomerType,
  setSelectedAbroadPackage,
  setSelectedFromSalePageFlag,
  setSearchingMode,
  removeOtpData,
  fetchPackage,
  setJETAuthentication,
  saveToHistory,
  setSmallResolution,
  setIsPortrait,
  setLobbyTabsButtons,
  PlantShadowMemo,
  PlantMemoBeforePackagePurchase,
  setOtpPopupData,
  setFromSuccess,
  abroadRetrieveCustomerData,
  setSaleActiveStep,
  setIsSelectingAccountBusinessIndividual,
  getCustomerCellularList,
  setOtpPhone,
  getAddonsPackage,
  setBuyPackageInSplit,
  setSwitchingAccount,
  saveSelectedCountry,
  saveSelectedCountries,
  setIsRegularAbroadCustomer,
  saveSelectedStartDate,
  saveSelectedEndDate,
  fetchPackageClient
} from './cellcomAbroadBlockSlice';
import {
  getCustomerAbroadPackagesBusinessIndividual,
  getUsageData,
  getCustomerAbroadPackages,
  getCustomerAbroadUsageDisplay,
} from './Shared/abroadThunk';
import CellcomAbroadLobby from './CellcomAbroadLobbyComponent';
import PopUp from '../../Shared/Popup/PopUp';
import OtpValidationResultPopupConstructor from './Popups/OtpValidationResultPopupConstructor';
import BasicErrorPopup from './Popups/BasicErrorPopup';
import CellcomAbroadPackagesHolderComponent from './Packages/CellcomAbroadPackagesHolderComponent';
import CellcomAbroadPopularPackagesHolderComponent from './Packages/CellcomAbroadPopularPackagesHolderComponent';
import PlaneLoader from '../AbroadTicketBlock/PlaneLoader';
import {getItem} from '../../../utilities/localStorageUtils';

import {gAPopupsLoadingReport} from './gAPopupsLoadingReport';
import {getReportParams, report} from '../../../middleware/report';
import lodash from 'lodash';
import {gAAbroadLobbyIsLoaded, gAAbroadBusinessIndividualLobbyIsLoaded} from './gaReports';
import {resetAuth} from '../../../utilities/authentication/authenticationSlice';
import {dwhGettingCustomerAbroadPackages} from './dwhReports';
import {OrganizationType} from './Shared/Models/AbroadPackageModels';
import IdfOrderPopUp from './Popups/IdfOrderPopUp';
import InterestedToBuyFromOrgPopup from './Popups/IsInterestedToBuyFromOrg';
import RestrictedCodePopup from 'app/Components/Block/CellcomAbroadLobbyBlock/Popups/RestrictedCodePopup';
import { isNullOrEmpty } from 'app/utilities/StringHelpers/StringHelpers';
import { formatDatesToDifferentFormats } from './cellcomAbroadUtilities';
import {hideAppLoader} from 'app/Components/Shared/Loader/LoaderSlice';

const CellcomAbroadMain = (props) => {
  const showExistingPackages = props.iContent.shouldDisplayPackageExists ? props.iContent.shouldDisplayPackageExists.value : true;
  const backgroundImage =
    isMobile || (isTablet && props.isPortrait) || props.data.isSmallResolution
      ? {backgroundImage: `url(${Config.epiBaseUrl + props.data.epiStyleInitializationData.lobbyBackgroundImageMobile})`}
      : {backgroundImage: `url(${Config.epiBaseUrl + props.data.epiStyleInitializationData.lobbyBackgroundImageDesktop})`};

  if (props.iContent.isBusinessIndividualLobby?.value && !props.portalsBlock.selectedHetPay) {
    let url = '';

    if (props.data.epiStyleInitializationData.businessIndividualLobby) {
      url = props.data.businessIndividualData.selfCareBlockUrl;
    }

    props.context.navigateTo(url);
  }

  const ref = useRef();
  const query = new URLSearchParams(window.location.search);
  ref.current = props.data;
  //--------------- useEffect ---------------
  useExtendedEffect((runSideEffects) => {
    props.setLoading(false);
    observeWindowSize();
    gaOnLoadLobbyPage();
    dwhEnterReport();
    props.setFromSuccess(false);
    if (runSideEffects()) {
      //coming from sale page with selected package
      const packageBlockId = query.get('packageBlockId');
      if (packageBlockId) {
        props.fetchPackage(packageBlockId);
      }
      const activeTab = query.get('activeTab');
      if (activeTab) {
        props.setActiveLobbyTab(activeTab);
      }
      
 

      //getting generalData and Popular packages

      if (props.iContent.isBusinessIndividualLobby?.value) {
        showExistingPackages
          ? props.setLobbyTabsButtons(lobbyTabsButtonsBusinessIndividual)
          : props.setLobbyTabsButtons(lobbyTabsButtonsBusinessIndividualWithoutPackagesButtons);
      } else {
        props.setLobbyTabsButtons(lobbyTabsButtonsToSelfCare);
      }

      props.epiStyleInitialization({generalData: props.iContent, currentPath: props.viewContext.currentPath});

      if (props.data.abroadPackagesPopular.length == 0) {
        const getEpiGeneralDataFunAsyncAwait = async () => {
          await props.getEpiGeneralData();
        };
        getEpiGeneralDataFunAsyncAwait();
      }

      props.setLoading(false);
      window.addEventListener('resize', observeWindowSize);

      if (props.iContent.isBusinessIndividualLobby?.value) {
        props.saveToHistory();
      }
    }
    if (props.iContent.isBusinessIndividualLobby?.value) {
      props.setSwitchingAccount(false);
    }
    if (
      props.iContent.isBusinessIndividualLobby?.value ||
      props.iContent.isCustomerServiceLobby?.value ||
      props.data.businessIndividualData.isFullFinancing
    ) {
      props.setIsRegularAbroadCustomer(false);
    } else {
      props.setIsRegularAbroadCustomer(true);
    }
    return () => {
      window.removeEventListener('resize', observeWindowSize);
    };
  }, []);

  useEffect(() => {
    const isPlaneLoaderActive =
      props.data.popularIsLoading || props.data.searchIsLoading || props.data.generalLoader;

    if (isPlaneLoaderActive && props.loader?.isLoading) {
      props.hideAppLoader();
    }
  }, [
    props.data.popularIsLoading,
    props.data.searchIsLoading,
    props.data.generalLoader,
    props.loader?.isLoading,
  ]);

  //------------------- package for business individual ------//
  const [selectedPackageToAdvance, setAdvancePackage] = useState(null);

  const continueWithIndividualPackage = async (setSplit) => {
    await props.setBuyPackageInSplit(setSplit);
    continueOrdering();
  };
  //------------------- package for business individual ------//

  //------------------- ga eCommerce ------//
  const [isCodeExecuted, setCodeExecuted] = useState(false);

  useEffect(() => {
    if (!isCodeExecuted && props.data.abroadPackagesPopular?.length > 0) {
      setCodeExecuted(true);
    }
  }, [props.data.abroadPackagesPopular, isCodeExecuted]);
  //------------------------------ ga eCommerce ------//

  //Tablet resolution fix
  useEffect(() => {
    props.setIsPortrait(props.isPortrait);
  }, [props.isPortrait]);

  //JET & login
  useEffect(() => {
    loadCustomer();
  }, [props.authentication.loginData]);

  useEffect(() => {
    if (props.data.otpData.saleOTPStep == saleOTPSteps.STEP_2_VALIDATED) {
      loadCustomer();
    }
  }, [props.data.activeLobbyTab]);

  function loadCustomer() {
    if (
      props.authentication?.loginData?.userDetails?.Impersonate &&
      props.authentication?.loginData?.userDetails?.loginSubType == loginSubTypes.ONBEHALF
    ) {
      props.setJETAuthentication(props.authentication.loginData.userDetails.contactNumber);
      let JETConnection = true;
      validateCustomerType({JETConnection});
    } else {
      if (!props.iContent.isBusinessIndividualLobby?.value) {
        let validateNumber;
        if (getItem('abroadOTP', true)) {
          const savedAccount = getItem('abroadOTP', true);
          validateNumber = savedAccount.validatedPhone;
        } else {
          validateNumber = props.authentication.loginData.userDetails.contactNumber;
        }
        if (
          (props.authentication?.loginData?.isFullAuthenticated || props.authentication?.loginData?.isOtpExtendedAuthenticated) &&
          !props.data.isJETAuthentication &&
          props.data.relatedPhoneNumbers.length == 0
        ) {
          props.getCustomerCellularList();
        } else if (
          ((props.data.activeLobbyTab == lobbyTabsEnum.BUSINESSACCOUNT || props.data.activeLobbyTab == lobbyTabsEnum.PRIVATE) &&
            props.authentication?.loginData?.isOtpAuthenticated) ||
          ((props.authentication?.loginData?.isFullAuthenticated || props.authentication?.loginData?.isOtpExtendedAuthenticated) &&
            getItem('abroadOTP', true) &&
            !props.data.otpData.otpPhone)
        ) {
          let JETConnection = false;
          let phoneNumber = validateNumber;
          validateCustomerType({JETConnection, phoneNumber});
        } else if (
          props.data.activeLobbyTab == lobbyTabsEnum.PACKAGEEXISTS &&
          (props.authentication?.loginData?.isOtpAuthenticated ||
            props.authentication?.loginData?.isOtpExtendedAuthenticated ||
            ((props.authentication?.loginData?.isFullAuthenticated || props.authentication?.loginData?.isOtpExtendedAuthenticated) &&
              !props.data.startedFromTracker))
        ) {
          validateExistedPackages(validateNumber);
        }
      } else {
        if (props.data.activeLobbyTab == lobbyTabsEnum.PACKAGEEXISTS_BUSINESSINDIVIDUAL) {
          if (props.data.businessIndividualData.selectedAccountNumber?.trim()) {
            validateExistedPackagesBusinessIndividual();
          } else {
            changeAccountBusinessIndividual();
          }
        }
      }
    }
  }

  useEffect(() => {
    if (props.data.activeLobbyTab == lobbyTabsEnum.PACKAGEEXISTS) {
      if (props.data.startedFromTracker && props.data.relatedPhoneNumbers?.length > 0) {
        validateExistedPackages(props.data.otpData.otpPhone);
      } else if (
        props.data.relatedPhoneNumbersRequestCompleted &&
        props.data.relatedPhoneNumbers.includes(props.authentication.loginData.userDetails.contactNumber)
      ) {
        validateExistedPackages(props.authentication.loginData.userDetails.contactNumber);
      } else return;
    } else {
      if (
        !props.data.validateCustomerTypeRequestCompleted &&
        props.data.relatedPhoneNumbersRequestCompleted &&
        props.data.relatedPhoneNumbers.includes(props.authentication.loginData.userDetails.contactNumber)
      ) {
        let JETConnection = props.data.isJETAuthentication;
        validateCustomerType({JETConnection});
      }
    }
  }, [props.data.relatedPhoneNumbersRequestCompleted]);

  //back implementation to lobby from #search_result
  window.onhashchange = function () {
    if (props.data.activeLobbyTab == lobbyTabsEnum.PACKAGEEXISTS) {
      return;
    }
    if (!props.data.abroadPackagesList) {
      let lastOtpData = getItem('abroadOTP', true);
      let validatedPhone = lastOtpData?.validatedPhone?.trim() != props.data.otpData.otpPhone ? lastOtpData?.validatedPhone?.trim() : '';
      if (validatedPhone) {
        let JETConnection = props.data.isJETAuthentication;
        let phoneNumber = validatedPhone;
        validateCustomerType({JETConnection, phoneNumber});
      }
    }

    if (props.data.otpData.validatedCostumerData?.accountType == customerTypeEnum.BUSINESS) {
      if (props.data.epiStyleInitializationData.businessIndividualLobby) {
        props.setActiveLobbyTab(lobbyTabsEnum.BUSINESSINDIVIDUAL);
      } else {
        props.setActiveLobbyTab(lobbyTabsEnum.BUSINESSACCOUNT);
      }
    } else {
      props.setActiveLobbyTab(lobbyTabsEnum.PRIVATE);
    }
  };

  //Popups Logic
  const currentPopup = useMemo(() => {
    if (props.data.popupReason == popupReasonEnum.OTP_RESULT && !props.data.otpData.otpPopupData) {
      props.closeModal();
      props.saveToHistory();
      return;
    }
    return getCurrentPopupContent();
  }, [props.data.isShowPopup, props.data.popupReason]);




  useEffect(() => {
    const magicLinkParams = props.authentication?.loginData?.magicLinkParameters?.jsonParameters;
     let countriesCodesList = [];
     let startDate = null;
     let endDate = null;
     let socCode = null;
    if(magicLinkParams){
      let params = JSON.parse(magicLinkParams);
      if(params.countryCode){
         countriesCodesList = params?.countryCode?.split(',');
          startDate = params?.startDate;
          endDate = params?.endDate;
          socCode = params?.socCode;
      }
    }else{
      const countriesCodes = query.get('countryCode');
     countriesCodesList = countriesCodes?.split(',');
      startDate = query.get('startDate');
      endDate = query.get('endDate');
      socCode = query.get('socCode');
    }
    const parseDate = (dateStr) => {
      const [day, month, year] = dateStr.split('/');
      return new Date(year, month - 1, day);
    };

    if ([countriesCodesList, startDate, endDate, props.data.allCountries].every(v => !isNullOrEmpty(v))) {
      const countries = props.data.allCountries.filter(
        (country) => countriesCodesList.includes(country.countryCode)
      );
  
      if (!isNullOrEmpty(countries) && !props.data.selectedCountries.length > 0) {
          props.saveSelectedCountries(countries);
          const start = parseDate(startDate);
          const end = parseDate(endDate);
          const today = new Date();
          today.setHours(0,0,0,0); 
  
          if (start >= today && end >= start ) {

            startDate = startDate.replaceAll('/', '.');
            endDate = endDate.replaceAll('/', '.');
            props.saveSelectedStartDate({ 
              selectedStartDate: startDate,
              datePickerStartJSFormat : formatDatesToDifferentFormats(start).formattedISOS,
              isQueryParam: true

             });
            props.saveSelectedEndDate({ 
              selectedEndDate: endDate,
              datePickerEndJSFormat : formatDatesToDifferentFormats(end).formattedISOS,
              isQueryParam: true
             });
            fetchPackage(countriesCodesList, startDate, endDate,socCode);
          }
        
      }
    }
  }, [props.data.allCountries]);


  const fetchPackage = async(countriesCodesList, startDate, endDate,socCode)=>{
    var blockId = props.data.otpData.isOTPValidated && props.data.otpData.validatedCostumerData.accountType == customerTypeEnum.BUSINESS
    ? props.data.epiStyleInitializationData.businessSocPackageFolderId
    : props.data.epiStyleInitializationData.privateSocPackageFolderId;

          const searchRequest = {
          CountryCodeList: [...countriesCodesList],
          DateStart: startDate,
          DateEnd:  endDate,
          BlockId: blockId,
        };
      await props.fetchPackageClient(searchRequest).then((res) => { 
      if(res.payload.response.matchExact?.length > 0){
        if(!isNullOrEmpty(socCode)){
          const soc = res.payload.response.matchExact.find(soc=>soc.socCode === socCode);
          if(soc){
            props.setSelectedAbroadPackage({ selectedPackage: soc});
          }
        }
      }
    });
  }


  //GA POPUPS
  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.data.popupReason) {
          let businessOrPrivate = customerTypeEnum.PRIVATE;
          if (props.data.activeLobbyTab == lobbyTabsEnum.BUSINESSACCOUNT) {
            businessOrPrivate = customerTypeEnum.BUSINESS;
          }
          if (
            props.data.popupReason == popupReasonEnum.OTP_RESULT &&
            (props.data.otpData.otpPopupData?.id ||
              (props.data.epiStyleInitializationData.businessIndividualLobby && props.data.businessIndividualData.popupData?.id))
          ) {
            gAPopupsLoadingReport({
              popupReason: props.data.popupReason,
              errorType: props.data.epiStyleInitializationData.businessIndividualLobby
                ? props.data.businessIndividualData.popupData.id
                : props.data.otpData.otpPopupData.id,
              startedFromPackage: props.data.startedFromPackage,
              businessOrPrivate: businessOrPrivate,
              isSeparatedSale: props.data.otpData.validatedCostumerData?.isSeparatedSale,
              isBusinessIndividual: props.data.epiStyleInitializationData.businessIndividualLobby,
              selectedPackage: props.data.selectedAbroadPackage,
            });
          } else if (props.data.popupReason == popupReasonEnum.ERROR_MESSAGE && props.data.businessIndividualData.popupData?.id) {
            gAPopupsLoadingReport({
              popupReason: props.data.popupReason,
              errorType: props.data.businessIndividualData.popupData.id,
              businessOrPrivate: businessOrPrivate,
              isBusinessIndividual: true,
              selectedPackage: props.data.selectedAbroadPackage,
            });
          } else {
            gAPopupsLoadingReport({
              popupReason: props.data.popupReason,
              startedFromPackage: props.data.startedFromPackage,
              businessOrPrivate: businessOrPrivate,
              isSeparatedSale: props.data.otpData.validatedCostumerData?.isSeparatedSale,
              isBusinessIndividual: props.data.epiStyleInitializationData.businessIndividualLobby,
              selectedPackage: props.data.selectedAbroadPackage,
            });
          }
        }
      }
    },
    [props.data.popupReason],
  );

  function getCurrentPopupContent() {
    let popup;
    switch (props.data.popupReason) {
      case popupReasonEnum.OTP_RESULT:
        popup = <OtpValidationResultPopupConstructor popupData={props.data.otpData.otpPopupData} context={props.context} />;
        break;
      case popupReasonEnum.ERROR_MESSAGE:
        let popupData = props.data.epiStyleInitializationData.businessIndividualLobby
          ? props.data.businessIndividualData.popupData
          : props.data.otpData.otpPopupData;
        popup = <BasicErrorPopup popupData={popupData} context={props.context} />;
        break;
      case popupReasonEnum.IDF_ORDER:
        popup = <IdfOrderPopUp goToSalePage={goToSalePage} />;
        break;
      case popupReasonEnum.BUY_WITH_ORG:
        popup = <InterestedToBuyFromOrgPopup setBuyInSplit={continueWithIndividualPackage} />;
        break;
      case popupReasonEnum.RESTRICTED_CODE_REQUIRED:
        popup = <RestrictedCodePopup />;
        break;
    }
    return popup;
  }

  const closeModal = () => {
    if (props.data.otpData.otpPopupData?.id == 'isPrivateAccount') {
      props.setActiveLobbyTab(lobbyTabsEnum.PRIVATE);
      if (props.data.selectedAbroadPackage) {
        props.setSelectedAbroadPackage(null);
      }
    } else if (props.data.otpData.otpPopupData?.id == 'isBusinessAccount') {
      props.setActiveLobbyTab(lobbyTabsEnum.BUSINESSACCOUNT);
      if (props.data.selectedAbroadPackage) {
        props.setSelectedAbroadPackage(null);
      }
    }

    if (props.data.otpData.isOtpValidatedPackageTab && !props.data.otpData.isOTPValidated) {
      let JETConnection = props.data.isJETAuthentication;
      validateCustomerType({JETConnection});
    }

    props.closeModal();
    props.saveToHistory();
  };

  //validate customer type function

  const validateCustomerType = async ({JETConnection, phoneNumber, type}) => {
    if (
      !phoneNumber &&
      !JETConnection &&
      !props.data.epiStyleInitializationData.businessIndividualLobby &&
      (props.authentication?.loginData?.isFullAuthenticated || props.authentication?.loginData?.isOtpExtendedAuthenticated) &&
      !props.data.relatedPhoneNumbers.includes(props.data.otpData.otpPhone) &&
      !props.data.relatedPhoneNumbers.includes(props.authentication.loginData.userDetails.contactNumber)
    ) {
      return null;
    } else {
      let validationResp = {};
      if (type) {
        validationResp.type = type;
      } else {
        validationResp.type =
          (props.data.otpData?.validatedCostumerData?.accountType == customerTypeEnum.PRIVATE ||
            props.data.activeLobbyTab == lobbyTabsEnum.PRIVATE ||
            JETConnection === true) &&
          props.data.otpData?.validatedCostumerData?.accountType != customerTypeEnum.BUSINESS
            ? customerTypeEnum.PRIVATE
            : customerTypeEnum.BUSINESS;
      }
      if (phoneNumber) {
        validationResp.phoneNumber = phoneNumber;
      } else {
        const otpData = getItem('abroadOTP', true);
        if (otpData) {
          validationResp.phoneNumber = otpData?.validatedPhone?.trim();
        } else {
          validationResp.phoneNumber = props.data.otpData.otpPhone || props?.selectedSelfcareSubscriber || props.authentication.loginData.userDetails.contactNumber;
        }
      }
      await props.validateCustomerType(validationResp);
      props.saveToHistory();
    }
  };

  const checkForSeparatedMove = (selectedPackage) => {
    if (
      props.data.otpData?.validatedCostumerData?.isSeparatedSale ||
      (props.data.otpData?.validatedCostumerData?.accountTypeIsValid?.item1 == 'Business' &&
        props.data.otpData?.validatedCostumerData?.accountTypeIsValid?.item2 == false)
    ) {
      props.setLoading(true);
      const sendObj = {
        phoneNumber: props.data.otpData.otpPhone,
        socCode: selectedPackage.socCode,
        startDate: props.data.dates.selectedStartDate,
        endDate: props.data.dates.selectedEndDate,
        type: 'Business',
        blockId: props.data.epiStyleInitializationData.businessSocPackageFolderId,
        countries: lodash.map(props.data.selectedCountries, 'countryCode'),
      };

      props.abroadRetrieveCustomerData(sendObj).then((res) => {
        props.setLoading(false);
        const customerData = res.payload.result;
        if (customerData?.isSeparatedSale) {
          if (customerData?.isDefaultSoc && customerData?.isDefaultSoc.length != 0) {
            props.setOtpPopupData(otpValidationPopupContent.separatedSaleDefaultPackage);
            props.openModal(popupReasonEnum.OTP_RESULT);

            props.PlantShadowMemo({
              banId: customerData.shadowData?.ban,
              soc: selectedPackage.socCode,
              subscriber: props.data.otpData.otpPhone,
              shadowBan: customerData.shadowData?.ban,
              memoType: '2',
            });
          } else if (customerData?.subsriberSurfIsBlocked && selectedPackage.type.toUpperCase().includes('DATA')) {
            if (selectedPackage.isBankOrByUse == 'ByUse') {
              props.setOtpPopupData(otpValidationPopupContent.abroadIsClosedForAccountSeparatedByUse);
            } else {
              props.setOtpPopupData(otpValidationPopupContent.abroadIsClosedForAccountSeparatedBank);
              props.setSelectedAbroadPackage(null);
            }
            props.openModal(popupReasonEnum.OTP_RESULT);

            props.PlantShadowMemo({
              banId: customerData.shadowData?.ban,
              soc: selectedPackage.socCode,
              subscriber: props.data.otpData.otpPhone,
              shadowBan: customerData.shadowData?.ban,
              memoType: '3',
            });
          } else if (customerData?.shadowData?.ban == '-1') {
            props.setSelectedAbroadPackage(null);
            props.setOtpPopupData(otpValidationPopupContent.separatedGeneralError);
            props.openModal(popupReasonEnum.OTP_RESULT);

            props.PlantShadowMemo({
              banId: customerData.shadowData?.ban,
              soc: selectedPackage.socCode,
              subscriber: props.data.otpData.otpPhone,
              shadowBan: customerData.shadowData?.ban,
              memoType: '4',
            });
          } else {
            props.PlantMemoBeforePackagePurchase({
              banId: customerData.shadowData.ban,
              soc: selectedPackage.socCode,
              subscriber: props.data.otpData.otpPhone,
              countries: lodash.map(props.data.selectedCountries, 'countryCode'),
              startDate: props.data.dates.selectedStartDate,
              endDate: props.data.dates.selectedEndDate,
            });
            props.context.navigateTo(props.data.epiStyleInitializationData.urlToSeparatedSale);
          }
        } else {
          checkOrgAndGoToSalePage();
        }
      });
    } else {
      checkOrgAndGoToSalePage();
    }
  };

  function checkOrgAndGoToSalePage() {
    if (props.organizationType?.value == OrganizationType.IDF) {
      props.openModal(popupReasonEnum.IDF_ORDER);
    } else {
      goToSalePage();
    }
  }

  function goToSalePage() {
    props.setLoading(true);
    props.goToPage(pages.SALE);
    props.setSaleActiveStep(saleActiveStep.TICKET);
    props.context.navigateTo(props.data.epiStyleInitializationData.urlToSaleBlock);
  }

  async function validateExistedPackages(phone) {
    const currentState = ref.current;
    if (
      !currentState.epiStyleInitializationData.businessIndividualLobby &&
      (props.authentication?.loginData?.isFullAuthenticated || props.authentication?.loginData?.isOtpExtendedAuthenticated) &&
      !currentState.isJETAuthentication
    ) {
      if (
        currentState.relatedPhoneNumbers.length == 0 &&
        !currentState.relatedPhoneNumbersRequestCompleted &&
        !currentState.startedFromTracker
      ) {
        return null;
      } else if (
        !phone &&
        currentState.relatedPhoneNumbers.length > 0 &&
        !currentState.relatedPhoneNumbers.includes(currentState.otpData.otpPhone) &&
        !currentState.relatedPhoneNumbers.includes(props.authentication.loginData.userDetails.contactNumber)
      ) {
        return null;
      }
    }

    let mobile;
    if (phone) {
      mobile = phone;
    } else {
      mobile = currentState.epiStyleInitializationData.businessIndividualLobby
        ? currentState.businessIndividualData.selectedAccountNumber
        : currentState.otpData.otpPhone || props.authentication.loginData.userDetails.contactNumber;
    }

    const data = {
      mobile: mobile,
      privateBlockId: props.privateId || props.iContent.privateSocPackageFolder?.expandedValue?.contentLink?.id,
      businessBlockId: props.businessId || props.iContent.businessSocPackageFolder?.expandedValue?.contentLink?.id,
      goldBusinessPackagesBlockId:
        currentState.epiStyleInitializationData.goldBusinessSocPackageFolderId ||
        props.iContent.goldBusinessSocPackageFolderId?.expandedValue?.contentLink?.id,
      showPopUp: false,
      addonsFolderBlockId: props.data.epiStyleInitializationData.addonsPackagesFolderId,
    };
    await props.getCustomerAbroadPackages(data).then((res) => {
      try {
        if (!res.payload.error) {
          getUsageDataAngAbroadUsage(mobile);

          const channel =
            res.payload?.result?.Body?.item2 && res.payload?.result?.Body?.item2 == 'CantSaleNow' ? 'WebsiteBusiness' : 'WebsitePrivate';
          const param1 = currentState.isJETAuthentication ? 'JET' : 'WEBSITE';
          let subscriber = currentState.otpData.otpPhone || '';
          let param4 = '';
          let param3 = res.payload?.result?.Body?.item2 && res.payload?.result?.Body?.item2 == 'CantSaleNow' ? 'מכר בהפרדה' : '';
          if (props.data.selectedAbroadPackage?.isFamilyBonus) {
            subscriber = currentState.otpDataChildren.otpPhone || '';
            param3 = 'בני משפחות';
            param4 = 'מספר מנוי ראשי - ' + currentState.otpData.otpPhone;
          }
          dwhGettingCustomerAbroadPackages({channel, subscriber, param1, param4, param3});
          if (
            props.data.relatedPhoneNumbers?.length == 1 &&
            props.data.relatedPhoneNumbers.includes(props.authentication.loginData.userDetails.contactNumber)
          ) {
            props.setOtpPhone(props.authentication.loginData.userDetails.contactNumber);
          }
        }
      } catch {}
    });
  }

  async function validateExistedPackagesBusinessIndividual() {
    const data = {
      phoneNumber: props.data.businessIndividualData.selectedAccountNumber,
      goldBusinessPackagesBlockId: props.iContent.goldBusinessSocPackageFolderId?.expandedValue?.contentLink?.id,
      blockId: props.iContent.businessSocPackageFolder?.expandedValue?.contentLink?.id,
      orgId: props.portalsBlock.privateCompanyList.find((org) => org.idNumber == props.portalsBlock.selectedHetPay).orgId,
    };
    await props.getCustomerAbroadPackagesBusinessIndividual(data).then((res) => {
      if (!res.payload.error) {
        getUsageDataAngAbroadUsage(props.data.businessIndividualData.selectedAccountNumber);
      }
    });
  }

  function getUsageDataAngAbroadUsage(mobile) {
    props.getUsageData({
      subscriber: mobile,
      toReport: false,
    });
    const dataUsage = {
      mobile: props.iContent.isBusinessIndividualLobby?.value ? props.data.businessIndividualData.selectedAccountNumber : mobile,
    };
    props.getCustomerAbroadUsageDisplay(dataUsage);
  }

  //go to sale page
  const continueOrdering = async (packageToContinue) => {
    let selectedPackage = selectedPackageToAdvance;
    if (packageToContinue) {
      selectedPackage = packageToContinue;
    }
    let folderType = props.data.activeLobbyTab == lobbyTabsEnum.PRIVATE ? customerTypeEnum.PRIVATE : customerTypeEnum.BUSINESS;
    let startedFromPackage = false;
    if (!props.data.dates.selectedStartDate || !props.data.dates.selectedEndDate || props.data.selectedCountries?.length == 0) {
      startedFromPackage = true;
    }
    props.setSelectedAbroadPackage({
      selectedPackage: selectedPackage,
      folderType: folderType,
      startedFromPackage: startedFromPackage,
    });

    if (props.data.dates.selectedStartDate && props.data.dates.selectedEndDate && props.data.selectedCountries?.length > 0) {
      props.setSearchingMode('');
      props.saveToHistory();
      checkForSeparatedMove(selectedPackage);
    } else {
      if (typeof window.scrollTo === 'function') {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });
      }
      props.data.selectedCountries?.length == 0
        ? props.setSearchingMode(searchParametersEnum.COUNTRY)
        : props.setSearchingMode(searchParametersEnum.DATES);
    }
  };

  function logout() {
    props.resetAuth();
    props.removeOtpData();
    props.saveToHistory();
  }

  function gaOnLoadLobbyPage() {
    if (props.iContent.isBusinessIndividualLobby?.value) {
      if (!props.data.businessIndividualData.viewWithoutPurchaseStatus && props.data.activeLobbyTab == lobbyTabsEnum.BUSINESSINDIVIDUAL) {
        gAAbroadBusinessIndividualLobbyIsLoaded();
      }
    } else {
      const tabName = lobbyTabsButtons.find((tab) => tab.id == props.data.activeLobbyTab)?.title;
      gAAbroadLobbyIsLoaded(tabName);
    }
  }

  function observeWindowSize() {
    window.outerWidth <= 980 ? props.setSmallResolution(true) : props.setSmallResolution(false);
  }

  function dwhEnterReport() {
    let reportParams = getReportParams();
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'Cellcom Abroad';
    reportParams.channel = 'WebsitePrivate';
    reportParams.actionType = 'Entered Cellcom abroad';
    reportParams.status = 'Ongoing';
    reportParams.messageText = 'Entered Cellcom abroad';
    reportParams.subscriber = '';
    reportParams.param1 = 'WEBSITE';
    if (props.data.isJETAuthentication) {
      reportParams.param1 = 'JET';
    }
    reportParams.param3 = props.data.otpData.validatedCostumerData?.isSeparatedSale ? 'מכר בהפרדה' : '';
    if (props.iContent.isBusinessIndividualLobby?.value) {
      reportParams.param3 = 'Individual';
      reportParams.param4 = props.portalsBlock.selectedHetPay;
    }
    report(reportParams);
  }

  const changeAccountBusinessIndividual = () => {
    const params = {
      isSelecting: true,
      removeSelectedAbroadPackage: false,
    };
    setIsSelectingAccountBusinessIndividual(params);
    props.context.navigateTo(props.data.businessIndividualData.selfCareBlockUrl);
  };

  function getShownPackages() {
    if (
      !props.data.abroadPackagesList &&
      (props.data.epiStyleInitializationData.listOfPrivatePopularSocIds?.length > 0 ||
        props.data.epiStyleInitializationData.listOfBusinessPopularSocIds?.length > 0)
    ) {
      if (
        props.data.selectedAbroadPackage ||
        (props.data.dates.selectedStartDate && props.data.selectedCountries?.length > 0) ||
        props.data.epiStyleInitializationData.businessIndividualLobby ||
        props.data.activeLobbyTab == lobbyTabsEnum.PACKAGEEXISTS ||
        (props.data.activeLobbyTab == lobbyTabsEnum.BUSINESSACCOUNT &&
          props.data.otpData.validatedCostumerData?.accountType != customerTypeEnum.BUSINESS)
      ) {
        return null;
      } else {
        return (
          <CellcomAbroadPopularPackagesHolderComponent
            orderEvent={(selectedPackage) => {
              setAdvancePackage(selectedPackage);
              if (
                // props.data.businessIndividualData?.buyPackageInSplit === null &&
                props.iContent.isBusinessIndividualLobby?.value &&
                !props.data.businessIndividualData?.isFullFinancing
              ) {
                props.openModal(popupReasonEnum.BUY_WITH_ORG);
              } else {
                continueOrdering(selectedPackage);
              }
            }}
            lobbyBlockId={props.data.epiStyleInitializationData.lobbyBlockId}
            context={props.context}
          />
        );
      }
    } else {
      if (!props.data.abroadPackagesList || props.data.selectedAbroadPackage) {
        return null;
      } else {
        return (
          <CellcomAbroadPackagesHolderComponent
            orderEvent={(selectedPackage) => {
              setAdvancePackage(selectedPackage);
              if (
                // props.data.businessIndividualData?.buyPackageInSplit === null &&
                props.iContent.isBusinessIndividualLobby?.value &&
                !props.data.businessIndividualData?.isFullFinancing
              ) {
                props.openModal(popupReasonEnum.BUY_WITH_ORG);
              } else {
                continueOrdering(selectedPackage);
              }
            }}
            context={props.context}
            changeAccountBusinessIndividual={changeAccountBusinessIndividual}
            businessIndividual={props.iContent.isBusinessIndividualLobby?.value || props.data.abroadPackagesList?.businessIndividual}
          />
        );
      }
    }
  }

  return (
    <div className={`cellcom-abroad-block ${isMobile || (isTablet && props.isPortrait) || props.data.isSmallResolution ? 'isMobile' : ''}`}>
      <div className='abroad-lobby-background' style={backgroundImage}></div>
      <div className={`cellcom-abroad-page-wrapper mr-auto ml-auto ${props.data.page == 'sale' ? 'sale-process' : ''}`}>
        {(props.data.popularIsLoading || props.data.searchIsLoading || props.data.generalLoader) && (
          <div className='loader-wrapper'>
            <PlaneLoader />
          </div>
        )}
        <Container className='cellcom-abroad-lobby-container'>
          <Row>
            <Col xs={12} className='mr-auto ml-auto'>
              <CellcomAbroadLobby
                iContent={props.iContent}
                context={props.context}
                validateCustomerType={(jetConnection, phone) => validateCustomerType(jetConnection, phone)}
                validateExistedPackages={validateExistedPackages}
                validateExistedPackagesBusinessIndividual={validateExistedPackagesBusinessIndividual}
                changeAccountBusinessIndividual={changeAccountBusinessIndividual}
              />
              {getShownPackages()}
            </Col>
          </Row>
          <PopUp
            className={props.data.popupReason}
            showPopUp={
              props.data.isShowPopup &&
              (props.data.popupReason == popupReasonEnum.OTP_RESULT ||
                props.data.popupReason == popupReasonEnum.ERROR_MESSAGE ||
                props.data.popupReason == popupReasonEnum.IDF_ORDER ||
                props.data.popupReason == popupReasonEnum.BUY_WITH_ORG ||
                props.data.popupReason == popupReasonEnum.RESTRICTED_CODE_REQUIRED)
            }
            onClose={() => closeModal()}>
            {currentPopup}
          </PopUp>
        </Container>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.cellcomAbroad,
    viewContext: state.ViewContext,
    authentication: state.authentication,
    businessId: state.cellcomAbroad.epiStyleInitializationData.businessSocPackageFolderId,
    privateId: state.cellcomAbroad.epiStyleInitializationData.privateSocPackageFolderId,
    portalsBlock: state.portalsBlock,
    organizationType: state.welcomeBlock.organizationState?.organizationType,
    selectedSelfcareSubscriber: state.selfcarePage?.selectedSubscriber?.productSubscriberNo,
    loader: state.loader,
  };
};

const mapDispatchToProps = {
  getEpiGeneralData,
  setLoading,
  epiStyleInitialization,
  resetState,
  setActiveLobbyTab,
  goToPage,
  validateCustomerType,
  openModal,
  closeModal,
  setSelectedAbroadPackage,
  setSelectedFromSalePageFlag,
  setSearchingMode,
  removeOtpData,
  resetAuth,
  fetchPackage,
  setJETAuthentication,
  saveToHistory,
  getCustomerAbroadPackages,
  getCustomerAbroadPackagesBusinessIndividual,
  getUsageData,
  getCustomerAbroadUsageDisplay,
  setSmallResolution,
  setIsPortrait,
  setLobbyTabsButtons,
  PlantShadowMemo,
  PlantMemoBeforePackagePurchase,
  setOtpPopupData,
  setFromSuccess,
  abroadRetrieveCustomerData,
  setSaleActiveStep,
  setIsSelectingAccountBusinessIndividual,
  getCustomerCellularList,
  setOtpPhone,
  getAddonsPackage,
  setBuyPackageInSplit,
  setSwitchingAccount,
  setIsRegularAbroadCustomer,
  saveSelectedCountry,
  saveSelectedStartDate,
  saveSelectedEndDate,
  fetchPackageClient,
  saveSelectedCountries,
  hideAppLoader,
};

export default withOrientationChange(connect(mapStateToProps, mapDispatchToProps)(CellcomAbroadMain));
